import Header from "components/books/Header";

function Books() {
  return (
    <>
      <Header />
    </>
  );
}

export default Books;
